export const BANK_APPROVED = '1';
export const BANK_PENDING = 0;
export const NEW_BANK_IS_APPROVED = BANK_PENDING;

const clean = (v) =>
  v === undefined || v === null ? '' : String(v).trim();

/** True only for an explicit approved flag; everything else is pending. */
export function isBankApproved(bank) {
  if (!bank) return false;
  const raw = bank.HEB_IS_APPROVED !== undefined ? bank.HEB_IS_APPROVED : bank.IS_APPROVED;
  if (raw === true) return true;
  if (raw === false) return false;
  const s = clean(raw).toLowerCase();
  return s === 'true' || s === '1' || s === 'yes';
}

export const isBankPending = (bank) => !isBankApproved(bank);


export function isBankActive(bank) {
  if (!bank) return true;
  // HEB_IS_ACTIVE is the employee-bank row's own flag ("True" / "False" from
  // GetEmployeebyID). HBD_IS_ACTIVE (the bank master) is only a fallback.
  const raw = bank.HEB_IS_ACTIVE !== undefined ? bank.HEB_IS_ACTIVE : bank.HBD_IS_ACTIVE;
  if (raw === undefined || raw === null || raw === '') return true;
  if (raw === true) return true;
  if (raw === false) return false;
  const s = clean(raw).toLowerCase();
  return !(s === 'false' || s === '0' || s === 'n' || s === 'no' || s === 'i');
}

/** Value sent as p_hebIsActive on EMP/UpdateEmployeeBank: 1 active, 0 inactive. */
export const bankActiveFlag = (active) => (active ? 1 : 0);

/** True only when HEB_IS_PRIMARY really means yes. The API sends text
    ("True" / "False"), and Boolean("False") is true — so never use Boolean(). */
export function isBankPrimary(bankOrValue) {
  const raw = bankOrValue && typeof bankOrValue === 'object'
    ? bankOrValue.HEB_IS_PRIMARY
    : bankOrValue;
  if (raw === true) return true;
  if (raw === false || raw === null || raw === undefined) return false;
  const s = clean(raw).toLowerCase();
  return s === 'true' || s === '1' || s === 'yes' || s === 'y';
}

/** The accounts on this employee that still need a decision. */
export const pendingBanks = (employee) =>
  (employee?.Banks || []).filter(isBankPending);

/** Stable key for a bank row — used for the tick-box state and React keys. */
export const bankKey = (bank) =>
  clean(bank?.HEB_EMPLOYEE_BANK_ID) || clean(bank?.HEB_ACCOUNT_NUMBER);

export function buildBankApprovalPayload(bank, approvedBy) {
  return {
    p_isApproved: BANK_APPROVED,
    p_hedApprovedBy: approvedBy,
    p_hedEmployeeId: bank.HEB_EMPLOYEE_ID,
    p_hebEmployeeBankId: bank.HEB_EMPLOYEE_BANK_ID,
    // Approving must not change whether the account is active.
    p_hebIsActive: bankActiveFlag(isBankActive(bank)),
  };
}